import {useIsBotModeEnabled, useRequest} from '@aboutyou/data-fetcher';
import {Log} from '@aboutyou/mlm';
import {useIsDataInfoMonitoringConsentGiven} from '@aboutyou/storage';
import {HEART_BEAT_PUBLIC_ROUTE} from './constants';

export const HeartBeat = () => {
  const hasConsent = useIsDataInfoMonitoringConsentGiven();

  const isBot = useIsBotModeEnabled();

  useRequest<{
    requestReceivedAt: string;
    pingStartedAt: string;
    pingEndedAt: string;
  }>(
    'heartbeat',
    async () => {
      const pingStartedAt = new Date().toISOString();

      const response = await fetch(HEART_BEAT_PUBLIC_ROUTE).then(res =>
        res.json(),
      );

      response.pingStartedAt = pingStartedAt;
      response.pingEndedAt = new Date().toISOString();

      return response;
    },
    {
      disabled: !hasConsent || isBot,
      onSuccess: data => {
        const pingStartedAt = new Date(data.pingStartedAt).getTime();
        const pingEndedAt = new Date(data.pingEndedAt).getTime();
        const requestReceivedAt = new Date(data.requestReceivedAt).getTime();

        const timeTakenForRequestToReachServer =
          requestReceivedAt - pingStartedAt;

        const timeTakenForResponseToReachClient =
          pingEndedAt - requestReceivedAt;

        const totalPingTime = pingEndedAt - pingStartedAt;

        Log.unSampledLog('HeartBeat', {
          timeTakenForRequestToReachServer,
          timeTakenForResponseToReachClient,
          totalPingTime,
        });
      },
    },
  );

  return null;
};
